import { clsx } from 'clsx';

import type { DatePickerProps, DateType, TextFieldProps } from 'ui';
import { CalendarIcon, CloserCrossIcon } from 'ui/icons';

interface AtomProps {
  className?: string;
  style?: Record<string, string | number>;
}

type UseDatePickerView = (
  props: DatePickerProps,
  classes: Record<string, string>,
  options: {
    openIconOnClick?: () => void;
    clearIconOnClick?: () => void;
    popupOpened: boolean;
  },
) => {
  textFieldProps: TextFieldProps;
  popupContainerProps: AtomProps;
  popupPaperProps: AtomProps;
  pickerMonthContainerProps: AtomProps;
  pickerMonthRibbonProps: AtomProps;
  pickerHeaderProps: AtomProps;
  pickerMonthProps: AtomProps;
  pickerWeekDayProps: AtomProps;
  pickerDayProps: { getClassName: (day: DateType) => string };
  pickerArrowsContainerProps: AtomProps;
  pickerArrowProps: AtomProps;
};

export const useDatePickerView: UseDatePickerView = (props, classes, options) => {
  const { readOnly, endAdornment, ...textFieldProps } = props;

  return {
    textFieldProps: {
      ...textFieldProps,
      endAdornment:
        endAdornment ||
        (readOnly ? undefined : (
          <>
            <div
              className={clsx(classes.openerIconContainer, classes.clear)}
              onClick={options.clearIconOnClick}
            >
              <CloserCrossIcon />
            </div>
            <div
              className={clsx(classes.openerIconContainer, {
                [classes.selected]: options.popupOpened,
              })}
            >
              <CalendarIcon />
            </div>
          </>
        )),
      tag: 'input',
      readOnly: true,
      fieldOnClick: options.openIconOnClick,
    },
    popupContainerProps: {
      className: clsx(classes.popupContainer),
    },
    popupPaperProps: {
      className: clsx(classes.popupPaper),
    },
    pickerMonthContainerProps: {
      className: clsx(classes.pickerMonthContainer),
    },
    pickerMonthRibbonProps: {
      className: clsx(classes.pickerMonthRibbon),
    },
    pickerHeaderProps: {
      className: clsx(classes.pickerHeader),
    },
    pickerMonthProps: {
      className: clsx(classes.pickerMonth),
    },
    pickerWeekDayProps: {
      className: clsx(classes.pickerWeekDay),
    },
    pickerDayProps: {
      getClassName: (day) =>
        clsx(classes.pickerDay, {
          [classes.today]: day.meta.isToday,
          [classes.isWeekend]: day.meta.isWeekend,
          [classes.isOutside]: !day.meta.isCurrentMonth,
        }),
    },
    pickerArrowsContainerProps: {
      className: clsx(classes.pickerArrowsContainer),
    },
    pickerArrowProps: {
      className: clsx(classes.pickerArrow),
    },
  };
};
